/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Actions_RegistrerenInputs */

const nl_common_actions_registreren = /** @type {(inputs: Common_Actions_RegistrerenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registreren`)
};

/**

* @param {Common_Actions_RegistrerenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_actions_registreren = /** @type {((inputs?: Common_Actions_RegistrerenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Actions_RegistrerenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_actions_registreren(inputs)
});
export { common_actions_registreren as "common.actions.registreren" }